<template>
  <BusyOverlay :is-showing="isBusy">
    <b-form-radio-group
      v-model="formData.delivery_option"
      @change="onDeliveryOptionChanged"
    >
      <b-form-radio
        value="leave_my_stuff"
        class="mb-3"
      >
        I would like to leave my things in storage and not have them delivered in September
      </b-form-radio>

      <b-form-radio
        value="custom_delivery"
      >
        I would like to have my items delivered to my off campus address
      </b-form-radio>
    </b-form-radio-group>

    <div
      v-if="formData.custom_delivery"
      class="text-center"
    >
      <a
        href="/orders/returns/create"
        class="btn btn-primary mt-3"
      >
        Schedule Custom Delivery
      </a>
    </div>
  </BusyOverlay>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import axios from 'axios';
import BusyOverlay from "@/UI/widgets/BusyOverlay.vue";

const LEAVE_MY_STUFF = "leave_my_stuff";
const CUSTOM_DELIVERY = "custom_delivery";

@Component({
  components: {BusyOverlay}
})
export default class MyStuffOptions extends Vue {
  @Prop({
    default: () => false
  })
  initialValue!: boolean;

  @Prop()
  featureKeyName!: string;

  formData = new class {
    delivery_option: string | null = null;
    leave_stuff_in_storage = false;
    custom_delivery = false;
  };

  isBusy = false;

  mounted() {
    this.formData.leave_stuff_in_storage = this.$props.initialValue;

    if (this.formData.leave_stuff_in_storage)
      this.formData.delivery_option = LEAVE_MY_STUFF;
  }

  onDeliveryOptionChanged(newValue) {
    console.debug('onDeliveryOptionChanged called');

    this.formData.leave_stuff_in_storage = newValue === LEAVE_MY_STUFF;
    this.formData.custom_delivery = newValue === CUSTOM_DELIVERY;
    this.submit();
  }

  submit() {
    this.isBusy = true;

    axios.post('/web-api/users/me/features', {
      features: [
        {
          key: this.$props.featureKeyName,
          value: this.formData.leave_stuff_in_storage
        }
      ]
    }).finally(() => {
      this.isBusy = false;
    });
  }
}
</script>

<style lang="scss" scoped>

</style>
